module.exports = __webpack_public_path__ + "img/jp-02.112dbb0d.png";